<template>
    <div class="page"> 
    </div>
</template>

<script>
 
import ConfigManager from '@/config/ConfigManager.js';
import CacheHelper from '@/helper/CacheHelper';

export default {
    name: "Logout", 
    components: { 
    },
    data: function () {
        return { 
        }
    },
    computed: { 
    },
    created: function() { 
        this.logout();
    },
    methods: { 
        logout: function(){
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            cacheHelper.removeCache('BzbsUser');
            this.$nextTick(() => {
                this.$router.push({ path: '/login', query: { app_id: this.appId } })
            }) 
        } 
    }
}
</script> 